import Axios from 'axios'

import keys from '@/config/keys'
import store from '@/redux/store'
import links from '@/config/links'
import endpoints from '@/config/endpoints'
import { setSettings } from '@/redux/slices/settingsSlice'
import { updateThemeViaCssVar } from '@/utils/updateTheme'
import setAxiosDefaultHeader from '@/utils/setAxiosDefaultHeader'
import { LOCAL_BUILD_NUMBER, LOCAL_VERSION_NUMBER } from '@/config/vars'

export const getAppSettings = async ({ fresh = false } = {}) => {
	const ep = `${endpoints.settings}${fresh ? `?timestamp=${Date.now()}` : ''}`
	const { data: settingsData } = await Axios.get(ep, { withCredentials: false })
	console.log('App Settings: ', settingsData)

	if (!settingsData) return null

	if (settingsData.title) document.title = settingsData.title
	const redirect_url = settingsData?.redirect_url
	if (redirect_url) window.location.href = redirect_url

	settingsData.isDev = settingsData.modeISLIST_Dev_Prod === 'Dev'
	settingsData.isProd = settingsData.modeISLIST_Dev_Prod === 'Prod'
	settingsData.menu = settingsData.menu.filter((item) => ![links.login.path].includes(item.link))

	store.dispatch(setSettings(settingsData))

	const eventId = settingsData[keys.FIELDS.eventId]
	const HEADERS = { [keys.HEADERS.EVENT_ID]: eventId }
	setAxiosDefaultHeader(true, HEADERS)

	updateThemeViaCssVar(settingsData?.branding)
	const splash_logo = (settingsData?.splash_logoISfile ?? settingsData?.logoISfile)?.uri
	if (splash_logo) localStorage.setItem(keys.SPLASH_LOGO, splash_logo)

	window[keys.APP_VERSION] = LOCAL_VERSION_NUMBER
	window[keys.APP_BUILD_NUMBER] = LOCAL_BUILD_NUMBER

	return settingsData
}
